<template>
  <div class="container">
    <div class="user-logined" v-if="user">
      <div class="user-header">
        <div class="user-avatar-wrapper" v-bind:style="{ 'background-image': 'url(' + pics.bg_user_center + ')' }">
          <img src="../../assets/images/user-icon.svg" />
          <p class="user-name">{{name}}</p>
        </div>
        <div class="user-num-wrapper">
          <div>
            <router-link to="/orderlist">
              <p class="sta-count">{{userState.orderCount}}</p>
              <p class="sta-text">个检预约</p>
            </router-link>
          </div>
          <div>
            <router-link to="/company/orderlist">
              <p class="sta-count">{{userState.companyOrderCount}}</p>
              <p class="sta-text">单位预约</p>
            </router-link>
          </div>
          <div>
            <router-link to="/reports">
              <p class="sta-count">{{userState.reportCount}}</p>
              <p class="sta-text">体检报告</p>
            </router-link>
          </div>
        </div>
      </div>
      <div class="cell-group">
        <van-cell title="体检人管理" icon="friends-o" is-link @click="$router.push({path:'/user/profileList'})" />
        <van-cell title="评估问卷" icon="records" is-link :to="{path:'/Survey'}" />
        <!-- <van-cell title="候补预约" icon="todo-list-o" is-link :to="{path:'/Survey'}" /> -->
        <!-- <van-cell title="发票管理" icon="balance-list-o" is-link /> -->
      </div>
      <div class="cell-group">
        <van-cell title="帮助中心" icon="question-o" is-link @click="dev" />
        <van-cell title="修改密码" icon="edit" is-link @click="$router.push({path:'/user/editpwd'})" />
      </div>

      <div class="cell-group" style="padding:0 16px;margin-top:60px">
        <van-button size="large" type="default" plain @click="logout()">退出登录</van-button>
      </div>
    </div>

    <div class="user-notlogin" v-else>
      <div><img src="@/assets/images/pic-notlogin.png" style="width:200px; margin-bottom:20px;" />
        <p class="user-nologin-text">您还没有登录</p>
        <van-button size="large" type="default" @click="Login()">登录/注册</van-button>
      </div>
    </div>
    <footerTabbar :activeIndex="2" />

  </div>
</template>

<style lang="less" scoped>
  .container {
    height: 100%;

    .user-notlogin {
      height: 80vh;
      margin: auto 0;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;

      .user-nologin-text {
        padding: 12px 0;
        color: #949494;
      }

      div {

        width: 100%;
        text-align: center;
      }
    }
  }

  .user-header {
    background: #fff;

    .user-avatar-wrapper {
      text-align: center;
      padding: 16px;
      background-image: url("../../assets/images/bg-user.png");
      background-size: 100% 100%;

      .user-name {
        font-size: 18px;
        color: #fff;
        margin-bottom: 16px;
      }
    }

    .user-num-wrapper {
      display: flex;
      text-align: center;

      div {
        padding: 12px;
        flex: 1;
      }

      .sta-count {
        font-size: 22px;
        margin-bottom: 8px;
        color: var(--color-main);
      }

      .sta-text {
        color: #949494;
      }
    }
  }

  .cell-group {
    margin-top: 12px;
  }
</style>

<script>
  import {
    mapState,
    mapMutations,
    mapActions
  } from "vuex";
  import * as auth from "@/libs/auth";
  import {
    pics
  } from '@/libs/common'
  import * as user_api from "@/api/user"
  import footerTabbar from "../components/footerTabbar.vue";
  export default {
    data() {
      return {
        name: "",
        user: null,
        userState: {
          reportCount: 0,
          orderCount: 0
        },
        pics
      }
    },
    computed: {
      ...mapState({
        hospInfo: state => state.hospital.hospInfo,
        assets: state => state.hospital.assets
      }),
      bg_user_center() {
        return this.getResourceUrl('--bg-user-center');
      }
    },

    components: {
      footerTabbar
    },
    mounted() {
      let userInfo = auth.getUser();
      if (userInfo) {
        this.name = userInfo.name;
        this.user = userInfo;
      } else {
        return;
      }
      user_api.getUserState().then(res => {
        if (res.code == 200) {
          this.userState = res.data;
        } else {
          this.userState = {
            reportCount: 0,
            orderCount: 0
          }
        }
      })
    },

    methods: {
      ...mapActions(
        "hospital", {
          setAssets: "setAssets"
        }
      ),
      getResourceUrl(resName) {
        if (!this.assets)
          return "";
        var res = this.assets.find(it => {
          return it.name == resName
        });
        if (!res)
          return ""
        else
          return res.value;
      },
      Login() {
        this.$router.push({
          path: "/login",
          query: {}
        })
      },
      logout() {
        let _this = this;
        user_api.logout().then(res => {
          auth.removeUser();
          _this.$toast("用户已退出登录");
          setTimeout(() => {
            _this.$router.push("/");
          }, 1000);
        })
      },
      dev() {
        this.$toast("功能暂不可用")
      }
    },
  };
</script>